import React, { Fragment, useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import close from "assets/images/close.svg";

import styles from "./BuyerPopup.module.scss";

const BuyerPopUp = ({ isOpen, toggle, isReadOnly, data, onSave, refresh }) => {
  useEffect(() => {
    setBuyer(data);
  }, [data]);

  useEffect(() => {
    if (!isOpen) {
      refresh();
    }
  }, [isOpen]);

  let [buyer, setBuyer] = useState();

  let [, setState] = useState();

  const handleChange = (event, index) => {
    let { value } = event.target;
    let formData = buyer;
    formData[index].notes = value;
    setBuyer(formData);
    setState(Math.random());
  };

  const onSubmit = () => {
    onSave(buyer);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalBody>
        <div className={styles.seller_popup_title}>
          <b>{isReadOnly ? "View Notes" : "Edit Notes"}</b>
          <div onClick={() => toggle()}>
            <img src={close} />
          </div>
        </div>
        {buyer?.length != 0 ? (
          <div className={styles.seller_directory}>
            <table className={styles.seller_popup}>
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {buyer?.map((list, index) => {
                  return (
                    <tr>
                      <td>{list.productName}</td>
                      <td>
                        {isReadOnly ? (
                          <span>{list.notes}</span>
                        ) : (
                          <textarea
                            value={list.notes}
                            onChange={(e) => handleChange(e, index)}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={`col-md-12 ${styles.empty_notes}`}>
            <span>No Records Found</span>
          </div>
        )}
        {!isReadOnly && (
          <SaveCancelBtn
            onCancel={toggle}
            onSave={onSubmit}
            position="center"
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default BuyerPopUp;
